module.exports = __webpack_public_path__ + "static/media/13.c3654127.png";